import { useCallback, useMemo } from 'react'
import { Alert, Button } from 'antd'
import { FileEditor } from './FileEditor'
import { WorkflowList } from './WorkflowList'
import { WorkflowEditor } from './WorkflowEditor'
import { useWorkflows } from '../hooks/useWorkflows'
import { RoleCards } from './RoleCards'
import { FileCatalog } from './FileCatalog'
import { DefinitionIcons } from './DefinitionIcons'
import type { useConfiguration } from '../hooks/useConfiguration'

export const ConfigurationPanel = ({ model }: { model: ReturnType<typeof useConfiguration> }) => {
  const workflows = useWorkflows(model.userId, model.instanceId, model.snapshot?.active_revision)
  const { hide } = workflows
  const { reload, selectFile } = model
  const selectConfiguration = useCallback((path: string) => { hide(); selectFile(path) }, [hide, selectFile])
  const catalogModel = useMemo(() => ({ ...model, file: workflows.visible ? undefined : model.file, selectFile: selectConfiguration }), [model, selectConfiguration, workflows.visible])
  const flowCatalog = <WorkflowList model={workflows} />
  const refresh = useCallback(() => { void reload().catch(() => undefined) }, [reload])
  const retryAction = <Button onClick={refresh} size="small">重新读取</Button>
  return <section className="instance-administration__configuration" aria-label="智能体角色配置">
    <RoleCards model={model} />
    <DefinitionIcons key={model.instanceId} model={model} />
    {model.readError ? <Alert type="error" showIcon title={model.readError.message} action={retryAction} role="alert" /> : null}
    <div className="instance-administration__configuration-grid">
      <FileCatalog key={model.instanceId} model={catalogModel} workflows={flowCatalog} />
      {workflows.visible ? <WorkflowEditor model={workflows} disabled={model.saving} /> : <FileEditor key={model.instanceId + ':' + (model.file?.path ?? '')} model={model} />}
    </div>
  </section>
}
